import React, { memo } from "react";

import { Icon, IIconProps } from "@/components/Icon";
import { Text } from "@/components/Text";
import { IMessage, TMessageType } from "@/eworkitComponents";
import { Flex } from "@/eworkitComponents";

interface IStickyProps extends IMessage {}

type TMessageTypeIconMap = Record<TMessageType, Pick<IIconProps, "icon">>;

const MessageTypeIconMap: TMessageTypeIconMap = {
  success: {
    icon: "checkbox-2",
  },
  information: {
    icon: "info-2",
  },
  danger: {
    icon: "warning-2",
  },
  warning: {
    icon: "warning-2",
  },
};

export const StickyMessage: React.FunctionComponent<IStickyProps> = memo(({ title, text, type = "information" }) => {
  const iconType = type as TMessageType;
  return (
    <Flex direction="row" padding={["md", false, "md", "sm"]} innerMargin="md">
      <Flex justify="center" align="center">
        <Icon icon={MessageTypeIconMap[iconType].icon} size="xxl" color="background-card" />
      </Flex>
      <Flex justify="center" innerMargin="sm" direction="column">
        {title && (
          <Text align="left" size="lg" whiteSpace="pre-wrap">
            {title}
          </Text>
        )}
        {text && (
          <Text align="left" size="lg" whiteSpace="pre-wrap">
            {text}
          </Text>
        )}
      </Flex>
    </Flex>
  );
});
